// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs_breadcrumbs__Fo0SJ typography_paragraphSmall__436Rg typography_bodyFont__Sn75r","breadcrumb":"breadcrumbs_breadcrumb__e8uSG"};